import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkAttachmentStatus } from 'common/api/attachments';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { attachmentsActions } from '../reducer';

import filterAttachments from './filterAttachments';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(attachmentsActions[BULK_UPDATE_ITEMS]());

    const newValues = {
        status_flag: value,
        items: ids,
    };

    bulkAttachmentStatus(newValues)
        .then(() => {
            dispatch(attachmentsActions[BULK_UPDATE_ITEMS_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(filterAttachments(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) =>
            dispatch(
                attachmentsActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
